import React from 'react';
import type { ClientMessage, Narrator, Snapshot } from '../shared/protocol';

export function RemoteNarrator({ snapshot, online, send }: { snapshot: Snapshot; online: boolean; send: (message: ClientMessage) => boolean }) {
  return <div className="remote-narrator">
    <label className="pack-select" htmlFor="game-narrator">Narrator
      <select id="game-narrator" value={snapshot.narrator ?? 'barnaby'} disabled={!online || snapshot.phase !== 'lobby'} aria-describedby="game-narrator-help" onChange={event => send({ type: 'narrator', gameId: snapshot.gameId, narrator: event.target.value as Narrator })}>
        <option value="barnaby">Barnaby</option>
        <option value="marshal">Marshal</option>
      </select>
    </label>
    <p id="game-narrator-help" className="fine">{snapshot.phase === 'lobby' ? 'One narrator for the whole game.' : 'Choose before starting the game.'}</p>
  </div>;
}
